import { render, staticRenderFns } from "./KPIContent.vue?vue&type=template&id=56534fcf&scoped=true&"
import script from "./KPIContent.vue?vue&type=script&lang=ts&"
export * from "./KPIContent.vue?vue&type=script&lang=ts&"
import style0 from "./KPIContent.vue?vue&type=style&index=0&id=56534fcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56534fcf",
  null
  
)

export default component.exports